import { render, staticRenderFns } from "./PopupAiVoiceWrite.vue?vue&type=template&id=6a67cf36&scoped=true"
import script from "./PopupAiVoiceWrite.vue?vue&type=script&lang=js"
export * from "./PopupAiVoiceWrite.vue?vue&type=script&lang=js"
import style0 from "./PopupAiVoiceWrite.vue?vue&type=style&index=0&id=6a67cf36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a67cf36",
  null
  
)

export default component.exports